import '../../App.css';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import i18n from "i18n-react";
import { DescriptionConfig, DescriptionGIE, NewGIE } from './DescriptionConfig';
import PropTypes from 'prop-types';
const url = process.env.REACT_APP_API_URL

class DynamicSelectedValuesTemplate extends React.Component {
    constructor(props) {
        super(props);
        let initialDetail = props.det;
        if (!initialDetail && props?.array?.detail) {
            initialDetail = props.array.detail[0];
        }

        const initialValue = initialDetail ? initialDetail.value : "";


        this.state = {
            form: props.array,
            detail: initialDetail,
            currentValueToShow: initialValue,
            selected: initialValue
        }
    }
    handleChange = (e) => {
        const newValue = Number(e.target.value);

        this.setState(prevState => {
            return {
                selected: newValue,
                detail: {
                    ...prevState.detail,
                    value: newValue
                }
            }
        });
    }

    render() {

        const options = this.props.array.companySettingTypeValue?.split(",") || [];
        const currentKey = this.state.form.key;

        return (
            <div className='col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                <DescriptionConfig keyValue={currentKey} />
                <div className='form-group row'>
                    <div className='col-sm-3 col-md-3 col-lg-3 col-xl-3'>
                        <b>{i18n.translate("current_value")}: </b>
                    </div>
                    <div className='col-sm-9 col-md-9 col-lg-9 col-xl-9'>
                        {i18n.translate(currentKey + "_" + this.state.detail.value)}
                    </div>
                </div>
                {this.state.form.update !== false &&
                    <DescriptionGIE type={this.state.detail.type} />
                }
                {this.state.form.update === false &&
                    <NewGIE />
                }

                <div className='form-group row'>
                    <div className='col-sm-3 col-md-3 col-lg-3 col-xl-3'>
                        <b>{i18n.translate("new_value")}: </b>
                    </div>

                    <div className='col-sm-9 col-md-9 col-lg-9 col-xl-9'>

                        <select
                            className="form-select selectStandard newValue"
                            name={currentKey}
                            value={this.state.selected}
                            onChange={this.handleChange}
                        >
                            {options.map((value) => (
                                <option key={`opt-${value}`} value={value}>
                                    {i18n.translate(currentKey + `_${value}`)}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        )
    }
}
DynamicSelectedValuesTemplate.propTypes = {
    array: PropTypes.shape({
        companySettingTypeValue: PropTypes.string,
        key: PropTypes.string,
        update: PropTypes.bool,
        detail: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string,
                type: PropTypes.string
            })
        )
    }),
    det: PropTypes.shape({
        value: PropTypes.string,
        type: PropTypes.string
    })
};

DynamicSelectedValuesTemplate.defaultProps = {
    array: {
        companySettingTypeValue: "",
        key: "",
        update: true,
        detail: [{ value: "", type: "" }],
        show: true
    },
    det: null
};

export default DynamicSelectedValuesTemplate;